module.exports = __webpack_public_path__ + "static/media/014-dental.ed595a12.svg";